/* import __COLOCATED_TEMPLATE__ from './alert-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface FiltersAlertOptionSignature {
  Args: {
    option: unknown;
  };
}

const FiltersAlertOptionComponent = templateOnlyComponent<FiltersAlertOptionSignature>();

export default FiltersAlertOptionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::AlertOption': typeof FiltersAlertOptionComponent;
    'filters/alert-option': typeof FiltersAlertOptionComponent;
  }
}
